function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:#1d1d1b;}.cls-2{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "familiar");

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M655,396.38h0a2,2,0,0,1-.5-2.78l4.48-6.43a2,2,0,0,1,2.78-.5h0a2,2,0,0,1,.5,2.78l-4.48,6.43A2,2,0,0,1,655,396.38Z",
  transform: "translate(-630.74 -338)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M651,387.43a5.92,5.92,0,1,1-5.92-5.92A5.92,5.92,0,0,1,651,387.43Z",
  transform: "translate(-630.74 -338)"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M11.11,56.74h6.38a2.72,2.72,0,0,1,2.72,2.72V74a2.72,2.72,0,0,1-2.72,2.72H11.11A2.72,2.72,0,0,1,8.39,74V59.47A2.73,2.73,0,0,1,11.11,56.74Z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M646.56,397.54h0a2,2,0,0,1,1.37-2.47l7.54-2.15a2,2,0,0,1,2.46,1.38h0a2,2,0,0,1-1.37,2.47L649,398.91A2,2,0,0,1,646.56,397.54Z",
  transform: "translate(-630.74 -338)"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M643.57,396.74h0a2,2,0,0,0-2-2h-8.84a2,2,0,0,0-2,2h0a2,2,0,0,0,2,2h8.84A2,2,0,0,0,643.57,396.74Z",
  transform: "translate(-630.74 -338)"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M631.14,397.94h0a2,2,0,0,0,2.8.4l6.27-4.7a2,2,0,0,0,.4-2.79h0a2,2,0,0,0-2.8-.41l-6.27,4.7A2,2,0,0,0,631.14,397.94Z",
  transform: "translate(-630.74 -338)"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M641.13,429.16h0a2,2,0,0,1-2-2V412.82a2,2,0,0,1,2-2h0c1.1,0,4.45.9,4.45,2l-2.45,14.34A2,2,0,0,1,641.13,429.16Z",
  transform: "translate(-630.74 -338)"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M648.88,429.16h0a2,2,0,0,0,2-2V412.82a2,2,0,0,0-2-2h0c-1.1,0-4.45.9-4.45,2l2.45,14.34A2,2,0,0,0,648.88,429.16Z",
  transform: "translate(-630.74 -338)"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M680.15,371.1c.76,10.51-5.36,13.89,7.93,29.37a16.45,16.45,0,0,1-2.5,1.74,52.25,52.25,0,0,1-8.52,3.14,94.41,94.41,0,0,1-11.41,2c-2-.22-6.32-9.8,1.52-19.06.68-2.75-7.66-7.76-6.95-10.77,2.6,2.45,5.56,3.16,8.6,1.9a26.85,26.85,0,0,0,6.12-3.89c2.82-2.24,4.52-5.44,6.41-8.43a1.44,1.44,0,0,1,1.57-.83c1.34.1,2.69,0,4.16,0a9.29,9.29,0,0,0-2-4.8c-1-1.45-2.12-2.84-3.13-4.29a2.23,2.23,0,0,1,.46-3.11,2.2,2.2,0,0,1,3,0,23.25,23.25,0,0,1,6.28,10.16,5.32,5.32,0,0,1-5,6.83C684.61,371.22,682.48,371.1,680.15,371.1Z",
  transform: "translate(-630.74 -338)"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M665.06,365.38a11.11,11.11,0,0,0,4.85,5.79c-1.78,2.47-3.91,3-5.78,1.38-.07,1.13.29,1.75,1.33,1.69a6.15,6.15,0,0,0,3.12-.85c2.13-1.62,4.32-3.19,5.65-5.71s3.15-5.13,4.75-7.69a2.23,2.23,0,0,1,2.85-.66,2.4,2.4,0,0,1,1.42,2.72,6.1,6.1,0,0,1-.6,1.33c-1.35,2.34-2.58,4.77-4.13,7a33.75,33.75,0,0,1-4.34,4.85,12.75,12.75,0,0,1-7.9,4c-3,.22-6.43-2-6.95-4.53-.87-4.14.63-7.3,4.1-8.61Z",
  transform: "translate(-630.74 -338)"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M677.59,406.16l6.68-2.3a49.48,49.48,0,0,1,4.63,19.66c0,1,.05,2,0,3.06a3.61,3.61,0,0,1-3.75,3.78,4,4,0,0,1-3.69-3.83,103.37,103.37,0,0,0-1.12-10.42C679.71,412.73,678.54,409.47,677.59,406.16Z",
  transform: "translate(-630.74 -338)"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M666.59,408.35l7.09-1.55a45.15,45.15,0,0,1,.48,5.07c-.09,4.93-.28,9.86-.51,14.78a3.82,3.82,0,0,1-2.62,3.64,3.74,3.74,0,0,1-4.69-4,78.68,78.68,0,0,0,.17-17.69C666.5,408.57,666.56,408.49,666.59,408.35Z",
  transform: "translate(-630.74 -338)"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M678.59,359.41l-2.5,3.75c-1.53,2.27-3.07,4.54-4.59,6.82a1.08,1.08,0,0,1-1.76.32c-5.06-3.58-4.68-9.09-.55-12.17a6.76,6.76,0,0,1,6.44-.76C676.91,357.82,678.12,358.33,678.59,359.41Z",
  transform: "translate(-630.74 -338)"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M704.81,372.83c1.88,0,3.69,0,5.51,0a3.8,3.8,0,0,0,3.62-2.27,3.62,3.62,0,0,0-3.66-5,27.45,27.45,0,0,1-11.47-2,22.33,22.33,0,0,1-10.82-9c-.88-1.39-1.14-3.2-2.84-4.05-.16-.08-.16-.66-.09-1a3,3,0,0,1,5.6-.83,36.84,36.84,0,0,0,2.93,5c4.09,5.07,9.27,8.32,16,8.24,5.25-.06,8.3,3.89,8.69,8.55a43,43,0,0,1-1.63,15.69c-.91,3.08-1.93,6.22-4.62,8.37a4.31,4.31,0,0,1-1.75,1.09c-1.27.21-1.6,1-1.86,2.06a43.19,43.19,0,0,0,1.71,25.92c1,2.77.1,5.16-2.41,6.38a4.2,4.2,0,0,1-5.79-2.09,50.44,50.44,0,0,1-2.19-33.52c1.25-4.53,2.77-9,3.92-13.53A76.54,76.54,0,0,0,704.81,372.83Z",
  transform: "translate(-630.74 -338)"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M707.4,359.36a7.59,7.59,0,1,1-.08-15.18,7.59,7.59,0,0,1,.08,15.18Z",
  transform: "translate(-630.74 -338)"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M722.28,354.71l5-3.07-.28,1.42c1.64,1.63,3.5,2.1,4.65,1.14,1.54-1.3,1.48-2.4-.23-4.58.77-.17,1.71-.12,2.27-.57a2.92,2.92,0,0,0,1.08-2.11c-.18-3.33-2.67-2.54-5.14-2.25.51-.73.81-1.13,1.07-1.54a2.24,2.24,0,0,0-.44-3.3,4.12,4.12,0,0,0-4.44-1c-1.65.67-2.15,2.13-2.18,3.8,0,.26,0,.52,0,1-2.3-.87-4.16-.52-4.7,2-.67,3.15,1.1,4.54,4.16,4.75a4,4,0,0,1-4.42-1.12,4.41,4.41,0,0,1-.56-4.87c.92-1.69,2.44-2.06,4.32-1.75.17-1.55.2-3.28,1.79-4a6,6,0,0,1,3.43-.64c3.6.77,4.63,1.94,4.16,5.55,2,.14,3.75.63,4.06,3,.22,1.73-.58,2.77-2.71,3.74,1,1.78.93,2.93-.43,4.1-1.75,1.5-3.78,1.22-6.08-.69-1.8.76-3.44,1.5-5.14,2.12-.38.14-.93-.16-1.4-.25a5.77,5.77,0,0,1,.51-1.19c1.07-1.49,2.18-2.94,3.36-4.51.63,1.95-1.19,3-1.89,4.4Z",
  transform: "translate(-630.74 -338)"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M728.94,350.2a8.6,8.6,0,0,0-.67-1.09,2.72,2.72,0,0,0-3.27-1c-.27.09-.64-.12-1-.2.24-.29.42-.75.72-.84C726.56,346.49,728.33,347.75,728.94,350.2Z",
  transform: "translate(-630.74 -338)"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M714.69,368.52a5.06,5.06,0,0,1-5.06,5.06h0a5.06,5.06,0,0,1-5.07-5.06h0a5.07,5.07,0,0,1,5.07-5.07h0a5.07,5.07,0,0,1,5.06,5.07Z",
  transform: "translate(-630.74 -338)"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M709.73,372a33.41,33.41,0,0,1-11.47,8.26,29.88,29.88,0,0,1-15.73,2.05,26.53,26.53,0,0,1-4-1,2.91,2.91,0,0,1-2.17-3.8,3.17,3.17,0,0,1,3.87-2,23,23,0,0,0,7.18,1,21.83,21.83,0,0,0,9.33-2.28,25.92,25.92,0,0,0,9.63-7.4,2.83,2.83,0,0,1,4.67,0,2.43,2.43,0,0,1,.25,3C710.83,370.58,710.26,371.27,709.73,372Z",
  transform: "translate(-630.74 -338)"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-2",
  d: "M709.73,372a33.41,33.41,0,0,1-11.47,8.26,29.88,29.88,0,0,1-15.73,2.05,26.53,26.53,0,0,1-4-1,2.91,2.91,0,0,1-2.17-3.8,3.17,3.17,0,0,1,3.87-2,23,23,0,0,0,7.18,1,21.83,21.83,0,0,0,9.33-2.28,25.92,25.92,0,0,0,9.63-7.4,2.83,2.83,0,0,1,4.67,0,2.43,2.43,0,0,1,.25,3C710.83,370.58,710.26,371.27,709.73,372Z",
  transform: "translate(-630.74 -338)"
});

var SvgFamiliar = function SvgFamiliar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 105.13 92.42",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : React.createElement("title", null, title), _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFamiliar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/familiar.c5a397c1.svg";
export { ForwardRef as ReactComponent };